export default (Vue) => {
  function checkValueType(value) {
    if (typeof value !== 'boolean') throw new TypeError('The value of the instruction v-focus should be of Boolean type');
  }

  // 切换选中的状态
  function toggleSeletedState(dom, state) {
    if (!dom) return null;
    if (state) dom.focus();
    else dom.blur();
  }

  /**
     * Sets the order
     *
     * @public
     * @version 1.0.5
     * @since Version 1.0.1
     * @param {string} key Key to order
     * @returns {string} Test
     */
  Vue.directive('focus', {
    // 当被绑定的元素插入到 DOM 中时……
    inserted(el, { value = true }) {
      checkValueType(value);
      const inputDom = el.querySelector('input');
      toggleSeletedState(inputDom, value);
    },
    // 当值更新时
    update(el, { value }) {
      checkValueType(value);
      const inputDom = el.querySelector('input');
      toggleSeletedState(inputDom, value);
    },
  });
};
